export default __webpack_public_path__ + "bml-characteristic4.13831ee.png";